import React from "react";
import MensageriaLogListPageContainer from "./MensageriaLogListPageContainer";

export class MensageriaLogListPage extends React.Component {
  render() {
    return <MensageriaLogListPageContainer {...this.props} />;
  }
}
